import { JourneyCanvasState } from '../../utility/TypeDefs';

/**
 * @method openSchedulerModal
 * @description Opens the scheduler modal.
 * @param {JourneyCanvasState} state - The current state of the journey canvas.
 * @returns {JourneyCanvasState} The updated state of the journey canvas.
 */
export const openSchedulerModal = (state: JourneyCanvasState): JourneyCanvasState => ({
  ...state,
  schedulerModal: true,
});

/**
 * @method closeSchedulerModal
 * @description Closes the scheduler modal.
 * @param {JourneyCanvasState} state - The current state of the journey canvas.
 * @returns {JourneyCanvasState} The updated state of the journey canvas.
 */
export const closeSchedulerModal = (state: JourneyCanvasState): JourneyCanvasState => ({
  ...state,
  schedulerModal: false,
});
